import CryptoJS from 'crypto-js'

/* eslint-disable no-unused-vars */

export function AESencrypt (secret = false, app = false, returnString = 0, async = false) {
  function crypto () {
    let key = CryptoJS.PBKDF2(app.key, app.salt, { hasher: CryptoJS.algo.SHA512, keySize: 64 / 8, iterations: 999 })
    var iv = CryptoJS.PBKDF2(app.key, app.salt, { keySize: 128 / 32, iterations: 999 })
    const encrypted = CryptoJS.AES.encrypt(secret, key,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    )
    if (returnString) {
      return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
    } else {
      return {
        iv: CryptoJS.enc.Hex.stringify(iv),
        encrypted: CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
      }
    }
  }
  if (secret && app) {
    if (async) {
      return new Promise(function (resolve) {
        var encTimeout = setTimeout(function () {
          resolve(crypto())
          clearTimeout(encTimeout)
        }, 0)
      })
    } else {
      return crypto()
    }
  } else {
    return false
  }
}

export function AESdecrypt (secret = false, app = false, async = false) {
  function isBase64(str) {
    try {
      return btoa(atob(str)) === str
    } catch (err) {
      return false
    }
  }
  function decrypto () {
    try {
      if (!isBase64(secret)) return false
      let key = CryptoJS.PBKDF2(app.key, app.salt, { hasher: CryptoJS.algo.SHA512, keySize: 64 / 8, iterations: 999 })
      var iv = CryptoJS.PBKDF2(app.key, app.salt, { keySize: 128 / 32, iterations: 999 })
      var cipherParams = CryptoJS.lib.CipherParams.create({
        ciphertext: CryptoJS.enc.Base64.parse(secret)
      })
      const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      })
      const result = decrypted.toString(CryptoJS.enc.Utf8)
      if (!result) return false
      return result
    } catch (e) {
      if (typeof window !== 'undefined' && window.app && window.app.dev_mode) {
        console.error('AESdecrypt error:', e)
      }
      return false
    }
  }
  if (secret && app) {
    if (async) {
      return new Promise(function (resolve) {
        var decTimeout = setTimeout(function () {
          resolve(decrypto() || false)
          clearTimeout(decTimeout)
        }, 55)
      })
    } else {
      return decrypto()
    }
  } else {
    return false
  }
}

export function userSession (app) {
  var session = localStorage.getItem('session') || false
  if (session) {
    var dec = AESdecrypt(session, app) || false
    if (dec) return JSON.parse(dec) || []
  }
  return false
}

export function themeSession (app) {
  var theme = localStorage.getItem('theme') || false
  const dftTheme = {
    dark: false,
    light: true
  }
  if (theme) {
    var dec = AESdecrypt(theme, app) || false
    if (dec) return JSON.parse(dec) || []
  }
  return dftTheme
}
